export enum NotificationSetting {
  NONE = 'NONE',
  APP_ONLY = 'APP_ONLY',
  EMAIL_ONLY = 'EMAIL_ONLY',
  BOTH = 'BOTH'
}
